import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/auth';

export default function Layout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="app-layout">
            <aside className="sidebar">
                <div className="sidebar-logo">MOVAL</div>
                <nav className="sidebar-nav">
                    <NavLink to="/" end>Dashboard</NavLink>
                    <NavLink to="/expedientes">Expedientes</NavLink>
                    <NavLink to="/ayuda">Ayuda N63</NavLink>
                </nav>
                <div style={{ marginTop: 'auto', fontSize: '0.85rem', opacity: 0.7 }}>
                    <div style={{ marginBottom: '8px' }}>{user?.name}</div>
                    <button onClick={handleLogout} className="btn btn-sm" 
                        style={{ background: 'rgba(255,255,255,0.1)', color: '#fff', width: '100%' }}>
                        Cerrar sesión
                    </button>
                </div>
            </aside>
            <main className="main-content">
                <Outlet />
            </main>
        </div>
    );
}
